<template>
  <div class="confirm-authentication-intro md:flex md:flex-col md:items-center lg:mt-[120px] ">
    <div class="title mx-6 mb-8 lg:max-w-[713px] sm:max-w-[700px] flex flex-col items-start">
      <h1 class="text-4xl mt-8 mb-5 md:mb-6 font-semibold">
        Eyewear for everyone
      </h1>
      <p class="text-lg">
        Redeem your free pair of Zenni glasses as part of your Molina healthcare plan.
        <br>All you need is your prescription &amp; insurance card.
      </p>
    </div>
    <div class="flex flex-center-align mb-10">
      <zn-button
        class="md:h-[60px]"
        @click="goToWelcome"
      >
        Get started
      </zn-button>
    </div>
    <template v-if="isMobile">
      <img
        src="/confirm-authentication-intro.png"
        class="w-full"
      >
      <div class="py-10 px-6 space-y-6">
        <h2 class="font-semibold text-lg">
          Find your frames in just a few steps:
        </h2>
        <ul class="relative space-y-2">
          <li class="list-item">
            <div class="icon" />
            <div class="leading-7">
              Verify Eligibility
            </div>
          </li>
          <li class="list-item">
            <div class="icon" />
            <div class="leading-7">
              Measure face size &amp; shape
            </div>
          </li>
          <li class="list-item">
            <div class="icon" />
            <div class="leading-7">
              Enter your prescription
            </div>
          </li>
          <li class="list-item">
            <div class="icon" />
            <div class="leading-7">
              Browse frames for you
            </div>
          </li>
        </ul>
      </div>
    </template>
    <div
      v-else
      class="flex flex-row border rounded-lg border-gray-border border-solid lg:max-w-[775px] sm:max-w-[715px] p-12"
    >
      <img
        src="/confirm-authentication-intro.png"
        class="w-[341px] h-[255px]"
      >
      <div class="flex flex-col ml-12 sm:ml-4">
        <h2 class="font-semibold text-lg">
          Find your frames in just a few steps:
        </h2>
        <ul class="relative space-y-2 mt-6">
          <li class="list-item">
            <div class="icon" />
            <div class="leading-7">
              Verify Eligibility
            </div>
          </li>
          <li class="list-item">
            <div class="icon" />
            <div class="leading-7">
              Measure face size &amp; shape
            </div>
          </li>
          <li class="list-item">
            <div class="icon" />
            <div class="leading-7">
              Enter your prescription
            </div>
          </li>
          <li class="list-item">
            <div class="icon" />
            <div class="leading-7">
              Browse frames for you
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ZnButton from '~/components/Zenni/ZnButton.vue';
import {onMounted, useRouter} from '@nuxtjs/composition-api';
import { useUiState, useBreakpoints, useUserZenni } from '~/composables';

export default {
  name: 'ConfirmAuthenticationIntro',
  components: { ZnButton },
  setup() {
    const {changeShowHeaderButtons, setBackButtonFunction, setHideBackButton} = useUiState();
    changeShowHeaderButtons(false);
    const router = useRouter();
    const goToWelcome = async() => {
      router.push('/confirmauthentication/welcome');
    };

    const { isMobile } = useBreakpoints();

    setHideBackButton(true);
    setBackButtonFunction(null);

    const { logoutUser } = useUserZenni();

    onMounted(async () => {
      await logoutUser();
    });

    return {
      goToWelcome,
      isMobile,
    };
  },
};
</script>

<style lang="scss" scoped>
.list-item {
  @apply text-teals flex space-x-2;

  .icon {
    @apply pt-1 w-6 h-6 flex-shrink-0;
    background-image: url('/icons/check-teal-icon.png');
    background-repeat: no-repeat;
    background-position: 0 4px;
  }
}


</style>
